import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import { FaPlus, FaSearch } from 'react-icons/fa';


const Status = () => {
  const [loading, setLoading] = useState(false);
  const [vinNumber, setVinNumber] = useState('');
  const [onboardResponse, setOnboardResponse] = useState([]);
  const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/; 

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
 
    const handleSubmitForm = (e) => {
        setOnboardResponse([]);
        const vinsArray = vinNumber.split(',').map(vin => vin.trim()).filter(vin => vin !== '');
        
        // Validation checks
        if (vinsArray.length === 0) {
            Swal.fire({ icon: 'error', text: 'Please enter at least one VIN Number.' });
            return;
        }

        if (vinsArray.length > 25) {
            Swal.fire({ icon: 'error', text: 'You can enter a maximum of 25 VINs only.' });
            return;
        }

        const invalidVins = vinsArray.filter(vin => !vinPattern.test(vin));
        if (invalidVins.length > 0) {
            Swal.fire({ icon: 'error', text: `Invalid VIN(s): ${invalidVins.join(', ')}` });
            return;
        }

        setLoading(true);
        axios.post(baseURL + "/vw_get_vehicle_status", {
            vin_list: vinsArray,
            admin_id: foundUser['tm_id']
        }).then((res) => {
            setLoading(false);
            if (res.data.data && res.data.data.fleet) {
                setOnboardResponse(res.data.data.fleet); // Save to state
            }

            Swal.fire({
                icon: 'success',
                title: "Processed"
            });

            setVinNumber('');
        });
    };

    const handleExportExcel = () => {
        axios({
            url: baseURL + "/vw_status_excel_export",
            method: "GET",
            responseType: "blob", // tells axios to expect binary data
        }).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "VW_VIN_Status.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).catch(() => {
            Swal.fire({ icon: "error", text: "Failed to export Excel." });
        });
    };


  return(
    <div className='body_class'>
      {loading ? (
          <div className="loader-overlay">
              <div className="loader">
              <PuffLoader color="#00308F" loading={true} size={200} />
              </div>
          </div>
      ) : ("")}
        <div className='container-fluid'>
            <h4>Check Vehicle Status</h4>
            <div className='mt-4'>
                <div className='container-fluid'>
                    <Form>
                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                        <Form.Label column sm="2">
                            VIN Numbers *
                        </Form.Label>
                        <Col sm="5">
                            <Form.Control type='text' value={vinNumber} placeholder='Enter up to 25 VINs, separated by commas' onChange={(e) => setVinNumber(e.target.value)} />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                        <Form.Label column sm="2"></Form.Label>
                        <Col sm="5" style={{"display": "flex", "gap": "45px"}}>
                        <Button variant="contained" onClick={handleSubmitForm}><FaSearch />&nbsp;Check Status</Button>
                        <Button variant="contained" color="success" onClick={handleExportExcel}>Export All VIN Status</Button>
                        </Col>
                        </Form.Group>
                    </Form>
                </div>
            </div>
            {onboardResponse.length > 0 && (
                <div className="mt-4 col-6">
                    <h5>Onboarding Results</h5>
                    <table className="table table-bordered">
                    <thead>
                        <tr>
                        <th>VIN</th>
                        <th>Consent Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {onboardResponse.map((item, idx) => (
                        <tr key={idx}>
                            <td>{item.vin}</td>
                            <td>{item.consentStatus}</td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
            )}
        </div>
    </div>
  )  
}

export default Status;